(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["SA-test-3d"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('jovi-viewer-v7')) return;

  let enginePromise;

  function ensureEngine() {
    if (customElements.get('model-viewer')) {
      return Promise.resolve();
    }

    if (enginePromise) return enginePromise;

    enginePromise = new Promise((resolve, reject) => {
      let settled = false;
      let ownScript;
      let delayed;

      const finish = error => {
        if (settled) return;

        settled = true;
        clearTimeout(timeout);
        clearTimeout(delayed);

        if (error) {
          ownScript?.remove();
          reject(error);
        } else {
          resolve();
        }
      };

      const timeout = setTimeout(
        () => finish(new Error('engine')),
        25000
      );

      customElements.whenDefined('model-viewer').then(() => finish());

      const insert = () => {
        if (settled) return;

        if (customElements.get('model-viewer')) {
          finish();
          return;
        }

        ownScript = document.createElement('script');
        ownScript.type = 'module';
        ownScript.src =
          'https://ajax.googleapis.com/ajax/libs/model-viewer/4.0.0/model-viewer.min.js';

        ownScript.addEventListener(
          'error',
          () => finish(new Error('engine')),
          { once: true }
        );

        document.head.append(ownScript);
      };

      const existing = Array.from(document.scripts).some(script =>
        /(?:^|\/)model-viewer(?:[.\w-]*)\.js(?:\?|$)/.test(script.src) &&
        !script.src.includes('model-viewer-ui')
      );

      if (existing) {
        delayed = setTimeout(insert, 2000);
      } else {
        insert();
      }
    }).catch(error => {
      enginePromise = null;
      throw error;
    });

    return enginePromise;
  }

  class JoviViewer extends HTMLElement {
    connectedCallback() {
      if (this.life || !this.dataset.src) return;

      this.viewer = this.querySelector('model-viewer');

      if (!this.viewer) {
        this.connectFrame = requestAnimationFrame(() => {
          if (this.isConnected) this.connectedCallback();
        });
        return;
      }

      this.life = new AbortController();
      const signal = this.life.signal;

      this.stage = this.querySelector('.jv7__stage');
      this.toolbar = this.querySelector('fieldset');
      this.status = this.querySelector('[data-status]');
      this.statusText = this.querySelector('[data-status-text]');
      this.retry = this.querySelector('[data-retry]');
      this.rotateButton = this.querySelector('[data-rotate]');
      this.expandButton = this.querySelector('[data-expand]');
      this.dialog = this.querySelector('dialog');

      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.rotating =
        this.dataset.rotate === 'true' && !this.motion.matches;

      this.inView = true;

      this.viewer.addEventListener(
        'load',
        () => this.ready(),
        { signal }
      );

      this.viewer.addEventListener(
        'error',
        () => this.fail('model'),
        { signal }
      );

      this.viewer.addEventListener('progress', event => {
        if (this.dataset.state !== 'loading') return;

        const percentage = Math.min(
          99,
          Math.round((event.detail.totalProgress || 0) * 100)
        );

        this.statusText.textContent =
          'Loading 3D model… ' + percentage + '%';
      }, { signal });

      this.viewer.addEventListener(
        'camera-change',
        () => this.updateZoom(),
        { signal }
      );

      ['pointerdown', 'keydown', 'wheel'].forEach(type => {
        this.viewer.addEventListener(
          type,
          () => this.setRotation(false),
          { signal, passive: true }
        );
      });

      this.rotateButton.addEventListener(
        'click',
        () => this.setRotation(!this.rotating),
        { signal }
      );

      this.querySelector('[data-reset]').addEventListener('click', () => {
        this.setRotation(false);
        this.viewer.resetTurntableRotation?.(0);
        this.fit(true);
      }, { signal });

      this.querySelectorAll('[data-zoom]').forEach(button => {
        button.addEventListener('click', () => {
          if (!this.bounds || !this.viewer.loaded) return;

          this.setRotation(false);

          const orbit = this.viewer.getCameraOrbit();
          const factor = button.dataset.zoom === 'in' ? .88 : 1 / .88;

          const radius = Math.max(
            this.bounds.min,
            Math.min(this.bounds.max, orbit.radius * factor)
          );

          this.viewer.cameraOrbit =
            orbit.theta + 'rad ' +
            orbit.phi + 'rad ' +
            radius + 'm';

          if (this.motion.matches) {
            this.viewer.jumpCameraToGoal?.();
          }
        }, { signal });
      });

      this.retry.addEventListener(
        'click',
        () => this.start(signal, true),
        { signal }
      );

      this.expandButton.addEventListener(
        'click',
        () => this.toggleExpanded(),
        { signal }
      );

      this.dialog.addEventListener(
        'close',
        () => this.restoreStage(),
        { signal }
      );

      document.addEventListener(
        'visibilitychange',
        () => this.syncRotation(),
        { signal }
      );

      this.motion.addEventListener('change', () => {
        if (this.motion.matches) this.setRotation(false);
      }, { signal });

      if ('IntersectionObserver' in window) {
        this.visibilityObserver = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.syncRotation();
        });

        this.visibilityObserver.observe(this);
      }

      if ('ResizeObserver' in window) {
        this.sizeObserver = new ResizeObserver(() => {
          if (this.dataset.state === 'ready') this.fit(false);
        });

        this.sizeObserver.observe(this.viewer);
      } else {
        window.addEventListener(
          'resize',
          () => this.fit(false),
          { signal }
        );
      }

      this.syncRotation();
      this.start(signal);
    }

    async start(signal, retry = false) {
      if (this.starting) return;

      this.starting = true;
      this.dataset.state = 'loading';
      this.setAttribute('aria-busy', 'true');

      this.status.hidden = false;
      this.retry.hidden = true;
      this.toolbar.disabled = true;
      this.statusText.textContent = 'Starting 3D viewer…';

      clearTimeout(this.loadTimer);

      try {
        await ensureEngine();

        if (signal.aborted) return;

        if (retry) {
          this.viewer.removeAttribute('src');
          await new Promise(resolve => setTimeout(resolve, 0));

          if (signal.aborted) return;
        }

        this.statusText.textContent = 'Loading 3D model…';

        this.loadTimer = setTimeout(
          () => this.fail('slow'),
          60000
        );

        this.viewer.src = this.dataset.src;

        if (this.viewer.loaded) this.ready();
      } catch (error) {
        if (!signal.aborted) this.fail('engine');
      } finally {
        if (this.life?.signal === signal) {
          this.starting = false;
        }
      }
    }

    ready() {
      clearTimeout(this.loadTimer);

      if (
        this.dataset.tint === 'true' &&
        this.viewer.model?.materials
      ) {
        try {
          let hex = this.dataset.color.replace('#', '');

          if (hex.length === 3) {
            hex = hex.split('').map(character => character + character).join('');
          }

          const rgb = [0, 2, 4].map(index =>
            parseInt(hex.slice(index, index + 2), 16) / 255
          );

          const linear = rgb.map(channel =>
            channel <= .04045
              ? channel / 12.92
              : Math.pow((channel + .055) / 1.055, 2.4)
          );

          this.viewer.model.materials.forEach(material => {
            const pbr = material.pbrMetallicRoughness;

            pbr?.setBaseColorFactor?.([...linear, 1]);
            pbr?.setMetallicFactor?.(0);
            pbr?.setRoughnessFactor?.(.65);
          });
        } catch (error) {
          console.warn('Jovi: keeping original materials.', error);
        }
      }

      this.fit(true);

      this.dataset.state = 'ready';
      this.setAttribute('aria-busy', 'false');
      this.status.hidden = true;
      this.toolbar.disabled = false;

      this.updateZoom();
      this.syncRotation();
    }

    fit(reset = false) {
      const viewer = this.viewer;

      if (
        !viewer?.loaded ||
        !viewer.getDimensions ||
        !viewer.getCameraOrbit
      ) return;

      const rect = viewer.getBoundingClientRect();
      const dimensions = viewer.getDimensions();

      const radius = Math.hypot(
        dimensions.x,
        dimensions.y,
        dimensions.z
      ) / 2;

      if (
        !rect.width ||
        !rect.height ||
        !radius ||
        !Number.isFinite(radius)
      ) return;

      const halfVertical = (
        viewer.getFieldOfView ? viewer.getFieldOfView() : 30
      ) * Math.PI / 360;

      const halfHorizontal = Math.atan(
        Math.tan(halfVertical) * rect.width / rect.height
      );

      const base = radius /
        Math.sin(Math.min(halfVertical, halfHorizontal)) *
        1.07;

      const mobile = matchMedia('(max-width: 749px)').matches;

      const limit = Number(this.dataset.maxZoom || 150) / 100;

      const scale = Math.min(
        limit,
        Number(
          mobile
            ? this.dataset.mobileSize
            : this.dataset.desktopSize
        ) / 100
      );

      const orbit = viewer.getCameraOrbit();

      const ratio = this.baseDistance
        ? orbit.radius / this.baseDistance
        : 1 / scale;

      const breakpointChanged = this.wasMobile !== mobile;

      this.wasMobile = mobile;
      this.baseDistance = base;

      this.bounds = {
        min: base / limit,
        max: base * 1.85
      };

      viewer.minCameraOrbit =
        'auto 5deg ' + this.bounds.min + 'm';

      viewer.maxCameraOrbit =
        'auto 175deg ' + this.bounds.max + 'm';

      const target = reset || breakpointChanged
        ? base / scale
        : base * ratio;

      const distance = Math.max(
        this.bounds.min,
        Math.min(this.bounds.max, target)
      );

      const theta = reset
        ? Number(this.dataset.azimuth) * Math.PI / 180
        : orbit.theta;

      const phi = reset
        ? Number(this.dataset.polar) * Math.PI / 180
        : orbit.phi;

      viewer.cameraOrbit =
        theta + 'rad ' +
        phi + 'rad ' +
        distance + 'm';

      viewer.jumpCameraToGoal?.();
      this.updateZoom();
    }

    updateZoom() {
      if (!this.bounds || !this.viewer.getCameraOrbit) return;

      const radius = this.viewer.getCameraOrbit().radius;

      this.querySelector('[data-zoom="in"]').disabled =
        radius <= this.bounds.min * 1.005;

      this.querySelector('[data-zoom="out"]').disabled =
        radius >= this.bounds.max * .995;
    }

    setRotation(value) {
      this.rotating = value;
      this.syncRotation();
    }

    syncRotation() {
      const active = Boolean(
        this.rotating &&
        this.inView &&
        !document.hidden &&
        this.dataset.state === 'ready'
      );

      this.viewer.toggleAttribute('auto-rotate', active);

      this.rotateButton.setAttribute(
        'aria-pressed',
        String(this.rotating)
      );

      this.rotateButton.setAttribute(
        'aria-label',
        this.rotating
          ? 'Pause automatic rotation'
          : 'Start automatic rotation'
      );

      this.rotateButton.querySelector('[data-rotate-label]').textContent =
        this.rotating ? 'Pause' : 'Rotate';
    }

    fail(kind) {
      clearTimeout(this.loadTimer);

      this.dataset.state = 'error';
      this.setAttribute('aria-busy', 'false');

      this.status.hidden = false;
      this.retry.hidden = false;
      this.toolbar.disabled = true;

      const messages = {
        engine: 'The 3D viewer could not start. Please try again.',
        model: 'The 3D model could not be loaded. Please try again.',
        slow: 'Loading is taking longer than expected. Please try again.'
      };

      this.statusText.textContent = messages[kind];
      this.syncRotation();
    }

    toggleExpanded() {
      if (this.dialog.open) {
        this.dialog.close();
        return;
      }

      if (!this.dialog.showModal) return;

      this.placeholder = document.createElement('div');
      this.placeholder.style.height = this.stage.offsetHeight + 'px';
      this.placeholder.style.minWidth = '0';

      this.stage.replaceWith(this.placeholder);
      this.dialog.append(this.stage);

      this.oldOverflow = document.documentElement.style.overflow;
      this.oldScroll = window.scrollY;

      document.documentElement.style.overflow = 'hidden';

      this.dialog.showModal();

      this.expandButton.dataset.expanded = 'true';
      this.expandButton.setAttribute('aria-label', 'Close expanded view');
      this.expandButton.focus({ preventScroll: true });

      requestAnimationFrame(() => {
        if (this.isConnected) this.fit(false);
      });
    }

    restoreStage() {
      if (!this.placeholder) return;

      this.placeholder.replaceWith(this.stage);
      this.placeholder = null;

      document.documentElement.style.overflow = this.oldOverflow;
      window.scrollTo(0, this.oldScroll);

      this.expandButton.dataset.expanded = 'false';
      this.expandButton.setAttribute('aria-label', 'Expand 3D view');

      if (this.isConnected) {
        this.expandButton.focus({ preventScroll: true });

        requestAnimationFrame(() => {
          if (this.isConnected) this.fit(false);
        });
      }
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.connectFrame);

      if (this.dialog?.open) {
        this.dialog.close();
      }

      this.restoreStage();
      this.visibilityObserver?.disconnect();
      this.sizeObserver?.disconnect();
      this.life?.abort();

      clearTimeout(this.loadTimer);

      this.viewer?.removeAttribute('auto-rotate');
      this.life = null;
      this.starting = false;
    }
  }

  customElements.define('jovi-viewer-v7', JoviViewer);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
